import { render, staticRenderFns } from "./LogoIcon-Profile.vue?vue&type=template&id=0d2e6b88"
import script from "./LogoIcon-Profile.vue?vue&type=script&lang=js"
export * from "./LogoIcon-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports